import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import ArticlePreviewSection from '@/pages/home/components/ArticlePreviewSection';
import FAQSection from '@/pages/home/components/FAQSection';
import CTASection from '@/pages/home/components/CTASection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturesSection />
        <ArticlePreviewSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'OOPBuy Spreadsheet Guide 2026 – Der ultimative Ratgeber',
            description:
              'Der ultimative OOPBuy Spreadsheet Guide. Finde die besten Spreadsheets für Schuhe, Kleidung und Accessoires. Alle Kategorien auf einen Blick.',
            url: `${import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.lol'}/`,
            inLanguage: 'de',
            dateModified: '2026-07-15',
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
            },
            isPartOf: {
              '@type': 'WebSite',
              name: 'oopbuyspread.lol',
              url: import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.lol',
            },
            about: {
              '@type': 'Thing',
              name: 'OOPBuy Spreadsheet',
              description: 'Kuratierte Shopping-Spreadsheets für OOPBuy mit 14 Kategorien',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: 'Startseite',
                  item: `${import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.lol'}/`,
                },
              ],
            },
          }),
        }}
      />
    </div>
  );
}